module.exports = __webpack_public_path__ + "img/inactive-priority.17367e2d.svg";